module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0004.jpg?v=bc10b51a";